<template>

  <Toast :group="page.name" position="bottom-center" />
  <Loader v-if="loader" />

  <div class="page">

    <div v-if="esito">
      <Message v-if="esito.inserite.length" severity="success" :closable="false">
        Richiesta di storno inserita per {{ esito.inserite.length }} fatture: {{ esito.inserite.join(', ') }}
      </Message>
      <Message v-if="esito.gia_presenti.length" severity="warn" :closable="false">
        Già presente una richiesta di storno per {{ esito.gia_presenti.length }} fatture, non inserite di nuovo:
        {{ esito.gia_presenti.join(', ') }}
      </Message>
    </div>

    <small>
      <div class="flex align-items-center text-sm mb-2">Fatture: {{ selectedItems.length }} selezionate su {{ items.length }}</div>
    </small>
    <DataTable :value="items" v-model:selection="selectedItems" dataKey="numero" tableStyle="width: 100%" responsiveLayout="scroll">
      <Column selectionMode="multiple" headerStyle="width: 3rem"></Column>
      <Column field="numero" header="Fattura" style="min-width: 120px"></Column>
      <Column field="ragsoc" header="Cliente" style="min-width: 200px"></Column>
      <Column field="mese_fatturazione" header="Mese Fatturazione" style="min-width: 140px">
        <template #body="{ data, field }">
          {{ data[field] ? moment(data[field]).format('MM/YYYY') : '' }}
        </template>
      </Column>
      <Column field="data_emissione" header="Data Emissione" style="min-width: 130px">
        <template #body="{ data, field }">
          {{ data[field] ? moment(data[field]).format('DD/MM/YYYY') : '' }}
        </template>
      </Column>
      <Column field="totale_fattura" header="Importo Fattura" style="min-width: 130px">
        <template #body="{ data, field }">
          {{ currencyFormatter.format(data[field] ?? 0) }}
        </template>
      </Column>
      <Column field="saldo" header="Saldo" style="min-width: 110px">
        <template #body="{ data, field }">
          {{ currencyFormatter.format(data[field] ?? 0) }}
        </template>
      </Column>
    </DataTable>
  </div>

  <div class="wrap-footer-main-dialog">
    <div class="footer-main-dialog">
      <Button
          label="Chiudi"
          icon="pi pi-times"
          iconPos="right"
          class="p-button-secondary mr-3"
          @click="onCancelButton($event)"
        />
        <Button
          v-if="!esito"
          label="Richiedi storno"
          icon="pi pi-check"
          iconPos="right"
          class="mr-3"
          :disabled="selectedItems.length === 0"
          @click="onOkButton($event)"
        />
    </div>
  </div>

</template>

<script>
import moment from 'moment'
import { ref, getCurrentInstance } from 'vue';
import ServiceFatture from '@/services/ask-management/fatture-clienti-service'
import Loader from '@/components/Loader.vue'
import { useToast } from "primevue/usetoast";

export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  components: {
    Loader
  },

  setup(props) {
    const page = { name: 'fatture-vendita-storna' }
    const loader = ref(false)
    const toast = useToast();
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus
    self.$http = self.appContext.config.globalProperties.$http
    const serviceFatture = new ServiceFatture(self.$http, self.$eventBus)
    const items = ref(props.data)
    const selectedItems = ref([...props.data])
    // risposta del backend: fatture inserite e fatture che avevano già una richiesta
    const esito = ref(null)
    const currencyFormatter = new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' })

    const onOkButton = async () => {
      toast.removeGroup(page.name);

      if (selectedItems.value.length === 0) {
        toast.add({ severity: 'warn', summary: 'Attenzione', detail: 'Nessuna fattura selezionata', group: page.name });
        return
      }

      loader.value = true
      try {
        const res = await serviceFatture.insertRichiesteStorno(selectedItems.value.map(el => el.numero))
        const payload = res?.data ?? {}

        if (!res?.meta?.success || !payload.success) {
          toast.add({ severity: 'error', summary: 'Errore', detail: 'Errore durante l\'inserimento delle richieste di storno', group: page.name });
          return
        }

        esito.value = {
          inserite: payload.inserite ?? [],
          gia_presenti: payload.gia_presenti ?? [],
        }
      } catch (error) {
        console.error('Errore durante l\'inserimento delle richieste di storno:', error)
        toast.add({ severity: 'error', summary: 'Errore', detail: 'Errore durante l\'inserimento delle richieste di storno', group: page.name });
      } finally {
        loader.value = false
      }
    }

    const onCancelButton = () => {
      self.$eventBus.emit(`dialog-return-cancel-button`, {})
    }

    return {
      moment,
      page,
      items,
      selectedItems,
      esito,
      loader,
      currencyFormatter,
      onOkButton,
      onCancelButton,
    }
  }
}
</script>
